

































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import {
  Button,
  Card,
  Form,
  FormItem,
  Input
} from 'element-ui';

// shipment document components
import ArrivalNotice from '@/components/documents/ArrivalNotice.vue';
import CustomsClearanceExport from '@/components/documents/CustomsClearanceExport.vue';
import CustomsClearanceImport from '@/components/documents/CustomsClearanceImport.vue';
import LandTransportationExport from '@/components/documents/LandTransportationExport.vue';
import LandTransportationImport from '@/components/documents/LandTransportationImport.vue';
import SeaWaybill from '@/components/documents/SeaWaybill.vue';
import ShippingInstructions from '@/components/documents/ShippingInstructions.vue';

// gql
import fetchShipmentDocument from '@/graphql/queries/document/Document.gql';
import updateDocumentMutation from '@/graphql/mutations/document/Update.gql';

// types
import {
  DocumentTypeEnum,
  ShipmentDocumentFields,
  ShipmentDocumentInput
} from '@/types/graphql/schemaTypes';

import rules from '@/rules/rules';

import scrollError from '@/mixins/scrollError';

@Component({
  apollo: {
    document: {
      query: fetchShipmentDocument,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          documentId: this.$route.params.document_id,
          shipmentId: this.$route.params.id
        };
      },
      update(data) {
        this.isNotFound = !data?.shipmentDocuments.length;
        return data?.shipmentDocuments[0] || null;
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    }
  },
  components: {
    ArrivalNotice,
    CustomsClearanceExport,
    CustomsClearanceImport,
    LandTransportationExport,
    LandTransportationImport,
    SeaWaybill,
    ShippingInstructions,
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class DocumentForm extends Mixins(scrollError) {
  private document: ShipmentDocumentFields | null = null;
  private isLoading = false;
  private isNotFound = false;
  private formInput: ShipmentDocumentInput = {
    title: null,
    data: null
  }

  private readonly rules = rules;

  $refs!: {
    documentForm: HTMLFormElement;
  };

  private loadDocumentForm(documentType: DocumentTypeEnum) {
    switch (documentType) {
      case DocumentTypeEnum.customs_clearance_export :
        return 'CustomsClearanceExport';
      case DocumentTypeEnum.customs_clearance_import :
        return 'CustomsClearanceImport';
      case DocumentTypeEnum.land_transportation_export :
        return 'LandTransportationExport';
      case DocumentTypeEnum.land_transportation_import :
        return 'LandTransportationImport';
      case DocumentTypeEnum.sea_waybill :
        return 'SeaWaybill';
      case DocumentTypeEnum.original_bill_of_landing :
        // "Original B/L" use the same form as "Sea Waybill"
        return 'SeaWaybill';
      case DocumentTypeEnum.arrival_notice :
        return 'ArrivalNotice';
      case DocumentTypeEnum.shipping_instructions :
        return 'ShippingInstructions';
    }
  }

  private submit(formData: any) {
    // set formInput for validation
    this.formInput.data = formData;

    this.$refs.documentForm.validate(async(valid: boolean) => {
      if (!valid || !this.document) {
        this.scrollError(this.$refs.documentForm);
        return;
      }

      this.isLoading = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: updateDocumentMutation,
          variables: {
            documentId: this.$route.params.document_id,
            documentAttributes: this.formInput
          }
        });

        if (response) {
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.document = response.data.updateShipmentDocument;
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.isLoading = false;
      }
    });
  }

  @Watch('document.title')
  setDocumentTitle(title: string | null) {
    // if document name is empty set to document type
    this.formInput.title = this.document.title || this.$t(`documentType.${this.document.documentType}`).toString();
  }
}
